(function() {
    'use strict';
    angular
        .module('emarket.main.profile')
        .factory('Profile', ['$mdDialog', 'restmod', '$q', '$http', 'PATH', function($mdDialog, restmod, $q, $http, PATH) {
            var profile = restmod.model('users');
            function makeHttpRequest(method, url, body) {
                var config = {
                    method: method,
                    url: url
                };
                if (body) {
                    config.data = body;
                }
                return $http(config).then(function(response) {
                    return response.data;
                });
            }
            profile.events = {
                HIDE_NAV_BAR: 'profile_hide_bar',
                HIDE_STAT_CARD: 'profile_hide_stat_card',
                PROFILE_PICTURE_UPLOAD: 'profile_picture_upload'
            };
            profile.phone = {
                types: [ 'mobile', 'work', 'home' ],
                status: {
                    UNVALIDATED: 'unvalidated',
                    VALIDATED: 'validated'
                }
            };
            profile.phone.types.WORK = 'work';
            profile.phone.types.MOBILE = 'mobile';
            profile.phone.types.HOME = 'home';
            profile.showCard = function(filter, object) {
                var promise;
                if (object) {
                    promise = $q.when(profile);
                } else {
                    var query = {};
                    Object.keys(filter).forEach(function(key) {
                        query[key] = filter[key];
                    });
                    if (query._id) {
                        promise = profile.$find(query._id).$asPromise();
                    } else {
                        promise = profile
                            .$search(query)
                            .$asPromise()
                            .then(function(result) {
                                return result[0];
                            });
                    }
                }
                return promise.then(function(user) {
                    return $mdDialog.show({
                        templateUrl: 'main/profile/card/profile-card.tpl.html',
                        controller: 'profileCard as model',
                        locals: {
                            user: user
                        }
                    });
                });
            };
            profile.getStat = function() {
                var url = PATH.api + '/profile/stats';
                return $http.get(url).then(function(response) {
                    var stat = response.data;
                    stat.percent = Math.round(stat.count / stat.total * 100);
                    return stat;
                });
            };
            profile.getEditPost = function(id) {
                var url = PATH.api + '/profile/products/' + id;
                console.log(url);
                return $http.get(url).then(function(response) {
                    return response.data;
                });
            };
            profile.getFavorites = function(type) {
                var url = PATH.api + '/profile/favorites?type=' + type;
                return makeHttpRequest('get', url);
            };
            profile.getCategories = function(id) {
                var url = PATH.api + '/users/store/' + id + '/categories';
                return $http.get(url).then(function(response) {
                    return response.data;
                });
            };
            profile.getConversations = function() {
                var url = PATH.api + '/profile/chats';
                return makeHttpRequest('get', url);
            };
            profile.getRelatedProducts = function(owner, skip, limit) {
                var url = PATH.api + '/users/posts/' + owner;
                var options = {
                    params: {}
                };
                if (skip) {
                    options.params.skip = skip;
                }
                if (limit) {
                    options.params.$limit = limit;
                }
                return $http.get(url, options).then(function(response) {
                    return response.data;
                });
            };
            profile.getPost = function(owner, skip, limit) {
                var url = PATH.api + '/profile/products';
                var options = {
                    params: {}
                };
                if (skip) {
                    options.params.skip = skip;
                }
                if (limit) {
                    options.params.$limit = limit;
                }
                return $http.get(url, options).then(function(response) {
                    return response.data;
                });
            };
            profile.validatePhone = function(phone, code) {
                var url = PATH.api + '/users/phone/validate';
                return $http
                    .post(url, {
                        phone: phone.number,
                        code: code
                    })
                    .then(function(response) {
                        return response.data;
                    })
                    .catch(function(response) {
                        throw response.data;
                    });
            };

            profile.showPhoneValidationDialog = function(phone, ignoreCall) {
                return $mdDialog.show({
                    templateUrl: 'main/profile/phone-validation-dialog/phone-validation.tpl.html',
                    controller: 'PhoneValidationDialogController as vm',
                    locals: {
                        phone: phone,
                        ignoreCall: ignoreCall
                    },
                    multiple: true
                });
            };
            profile.sendPhoneValidation = function(phone) {
                var url = PATH.api + '/users/phone/validate/send';
                return $http
                    .post(url, {
                        phone: phone.number
                    })
                    .then(function(response) {
                        return response.data;
                    });
            };
            profile.addSeasonPosts = function(posts) {
                var url = PATH.api + '/users/store/season-posts';
                return makeHttpRequest('post', url, { posts: posts });
            };
            profile.addHighlightedPosts = function(posts) {
                var url = PATH.api + '/users/store/highlighted-posts';
                return makeHttpRequest('post', url, { posts: posts });
            };
            profile.removeSeasonPosts = function(posts) {
                var url = PATH.api + '/users/store/season-posts';
                return makeHttpRequest('delete', url, { posts: posts });
            };
            profile.removeHighlightedPosts = function(posts) {
                var url = PATH.api + '/users/store/highlighted-posts';
                return makeHttpRequest('delete', url, { posts: posts });
            };
            profile.changePassword = function(currentPassword, newPassword) {
                return makeHttpRequest('post', PATH.api + '/profile/change-password', {
                    newPassword: newPassword,
                    currentPassword: currentPassword
                });
            };
            profile.showChangePasswordDialog = function(user) {
                $mdDialog.show({
                    templateUrl: 'main/profile/change-password-dialog/change.password.dialog.tpl.html',
                    controller: 'ChangePasswordDialogController as vm',
                    locals: {
                        user: user
                    }
                });
            };
            profile.showAddBalanceDialog = function(user) {
                $mdDialog.show({
                    templateUrl: 'main/profile/transaction/add.balance.dialog.tpl.html',
                    controller: 'AddBalanceDialogController as vm',
                    locals: {
                        user: user
                    }
                });
            };
            profile.showBuyPlanDialog = function(plans, plan) {
                return $mdDialog.show({
                    templateUrl: 'main/profile/buy/buy.dialog.tpl.html',
                    controller: 'BuyDialogController as vm',
                    locals: {
                        plan: plan,
                        plans: plans
                    }
                });
            };
            return profile;
        }]);
}());
